// Communication bridge with the Chrome extension

export class ExtensionBridge {
  // Send auth token to extension via postMessage
  static async sendAuthToken(token: string): Promise<void> {
    try {
      console.log('ExtensionBridge: Sending auth token to extension');

      // Store token in localStorage as backup
      localStorage.setItem('resistor_auth_token', token);
      localStorage.setItem('resistor_token_timestamp', Date.now().toString());

      // Post message to content script
      window.postMessage({
        type: 'RESISTOR_AUTH_TOKEN',
        token: token
      }, window.location.origin);

      console.log('Dashboard: Auth token sent to extension via postMessage');
    } catch (error) {
      console.warn('Dashboard: Failed to send auth token:', error);
    }
  }

  // Clear auth token from extension when user signs out
  static async clearAuthToken(): Promise<void> {
    try {
      console.log('ExtensionBridge: Clearing auth token for extension');
      localStorage.removeItem('resistor_auth_token');
      localStorage.removeItem('resistor_token_timestamp');

      // Post message to content script to clear token
      window.postMessage({
        type: 'RESISTOR_CLEAR_AUTH'
      }, window.location.origin);

      console.log('Dashboard: Auth token clear message sent to extension');
    } catch (error) {
      console.warn('Dashboard: Failed to clear extension auth token:', error);
    }
  }

  // Sync resistances to extension when they're updated
  static async syncResistances(): Promise<void> {
    try {
      console.log('ExtensionBridge: Triggering resistance sync');
      // Trigger a custom event for resistance sync
      localStorage.setItem('resistor_sync_timestamp', Date.now().toString());
      
      window.dispatchEvent(new CustomEvent('resistor-sync-resistances'));
      console.log('Dashboard: Resistance sync triggered');
    } catch (error) {
      console.warn('Dashboard: Failed to trigger resistance sync:', error);
    }
  }
}